import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import SolutionFinder from "."

const StoryblokSolutionFinder = ({
  blok,
}: Storyblok.BlokProps<Storyblok.SolutionFinder>) => {
  return (
    <SolutionFinder
      variant={blok.variant}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokSolutionFinder
